export default __webpack_public_path__ + "static/media/Εικόνα1.8a3e1191.png";